import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " - ", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useProductClickAndCollect from '@/shared/product/purchase/ui/useProductClickAndCollect';
import {
    ClickAndCollectPurchaseOption, ProductClickAndCollectStoreInventoryResult, PurchaseOption,
} from '@/types/productServerApi';
import { computed, ComputedRef } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPurchaseOptionClickAndCollectDescription',
  props: {
    purchaseOption: null,
    isSingleOption: { type: Boolean, default: false }
  },
  setup(__props: any) {



const {
    openStoreSelector,
    openStoreInfo,
    setClickAndCollectStoreInfo,
    amountOfStoresWithStock,
    storeInventoryData,
    storeId,
} = useProductClickAndCollect();

const labels = useBlockLabels();

const onStoreInfoClick = () => {
    setClickAndCollectStoreInfo();
    openStoreInfo();
};

const showAmountOfStoresWithStock = computed(() => {
    return amountOfStoresWithStock.value !== null && amountOfStoresWithStock.value !== 0;
});

const store: ComputedRef<ProductClickAndCollectStoreInventoryResult | undefined> = computed(() => {
    return storeInventoryData.value?.find((store) => store?.storeId === storeId.value);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "o-anim-fade-300" }, {
      default: _withCtx(() => [
        (_unref(showAmountOfStoresWithStock))
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
              _createTextVNode(" - "),
              _createElementVNode("button", {
                type: "button",
                class: "c-link c-magic-line c-magic-line--underline",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(openStoreSelector)()), ["prevent"]))
              }, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).clickAndCollectAmountOfStoresWithStock, { quantity: _unref(amountOfStoresWithStock) })), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("span", {
      class: _normalizeClass(["flex flex-col w-full flex-no-shrink -mt-3 gap-8", {'ml-30': !__props.isSingleOption}])
    }, [
      _createVNode(_Transition, {
        name: "o-anim-fade-300",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_unref(storeId) && _unref(store) && _unref(store).storeTitle)
            ? (_openBlock(), _createElementBlock("span", { key: _unref(storeId) }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "c-link c-magic-line c-magic-line--underline",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onStoreInfoClick()), ["prevent"]))
                }, _toDisplayString(_unref(store).storeTitle), 1),
                _createVNode(_Transition, {
                  name: "o-anim-fade-300",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("span", {
                      key: _unref(store).status.namedParams.storeInventoryCount
                    }, [
                      _hoisted_2,
                      (_unref(store).status.namedParams.storeInventoryCount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).clickAndCollectStockForSelectedStore, { quantity: _unref(store).status.namedParams.storeInventoryCount })), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(labels)[_unref(store).status.label]), 1))
                    ]))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2)
  ], 64))
}
}

})